// Centralized i18n strings: ar (Arabic, RTL) and en (English, LTR)
export const STRINGS = {
  app_name: { ar: "نطاق للتسوق", en: "Nitaq Shopping" },
  app_subtitle: { ar: "سوقك إلى التطبيق", en: "Your market in your app" },
  cancel: { ar: "إلغاء", en: "Cancel" },
  save: { ar: "حفظ", en: "Save" },
  delete: { ar: "حذف", en: "Delete" },
  edit: { ar: "تعديل", en: "Edit" },
  add: { ar: "إضافة", en: "Add" },
  close: { ar: "إغلاق", en: "Close" },
  done: { ar: "تم", en: "Done" },
  loading: { ar: "جارٍ التحميل...", en: "Loading..." },
  error: { ar: "خطأ", en: "Error" },
  success: { ar: "تم", en: "Success" },
  retry: { ar: "إعادة المحاولة", en: "Retry" },
  search: { ar: "بحث", en: "Search" },
  search_placeholder: { ar: "ابحث عن منتج...", en: "Search for a product..." },
  next: { ar: "التالي", en: "Next" },
  back: { ar: "رجوع", en: "Back" },
  confirm: { ar: "تأكيد", en: "Confirm" },
  optional: { ar: "اختياري", en: "Optional" },
  required: { ar: "مطلوب", en: "Required" },
  yes: { ar: "نعم", en: "Yes" },
  no: { ar: "لا", en: "No" },

  login: { ar: "تسجيل الدخول", en: "Sign In" },
  register: { ar: "إنشاء حساب", en: "Sign Up" },
  logout: { ar: "تسجيل الخروج", en: "Sign Out" },
  email: { ar: "البريد الإلكتروني", en: "Email" },
  password: { ar: "كلمة المرور", en: "Password" },
  name: { ar: "الاسم", en: "Name" },
  full_name: { ar: "الاسم الكامل", en: "Full Name" },
  forgot_password: { ar: "نسيت كلمة المرور؟", en: "Forgot password?" },
  no_account: { ar: "ليس لديك حساب؟", en: "Don't have an account?" },
  have_account: { ar: "لديك حساب؟", en: "Have an account?" },
  continue_with_google: { ar: "متابعة باستخدام Google", en: "Continue with Google" },
  continue_as_guest: { ar: "متابعة كزائر", en: "Continue as Guest" },
  guest_mode: { ar: "وضع الزائر", en: "Guest Mode" },

  choose_role: { ar: "اختر نوع حسابك", en: "Choose your account type" },
  role_buyer: { ar: "مشتري", en: "Buyer" },
  role_buyer_desc: { ar: "تصفح المنتجات والشراء", en: "Browse and buy products" },
  role_seller: { ar: "متجر", en: "Store" },
  role_seller_desc: { ar: "بيع منتجاتك للجميع", en: "Sell products to everyone" },
  role_driver: { ar: "سائق", en: "Driver" },
  role_driver_desc: { ar: "تقديم خدمة التوصيل", en: "Offer delivery services" },
  seller_type_shop: { ar: "متجر محلي", en: "Local Shop" },
  seller_type_online: { ar: "متجر إلكتروني", en: "Online Store" },
  browse_marketplace: { ar: "تصفّح المتاجر", en: "Browse Marketplace" },
  my_products: { ar: "منتجاتي", en: "My Products" },
  marketplace: { ar: "السوق", en: "Marketplace" },

  tab_home: { ar: "الرئيسية", en: "Home" },
  tab_search: { ar: "بحث", en: "Search" },
  tab_orders: { ar: "الطلبات", en: "Orders" },
  tab_chats: { ar: "المحادثات", en: "Chats" },
  tab_profile: { ar: "الملف الشخصي", en: "Profile" },

  home_title: { ar: "الرئيسية", en: "Home" },
  promoted_badge: { ar: "ممول", en: "Sponsored" },
  out_of_stock: { ar: "نفذ", en: "Sold Out" },
  no_products: { ar: "لا توجد منتجات بعد", en: "No products yet" },
  add_product: { ar: "إضافة منتج جديد", en: "Add New Product" },
  all_lists: { ar: "كل القوائم", en: "All Lists" },
  recommended_for_you: { ar: "مقترح لك", en: "Recommended for you" },
  promoted_section: { ar: "منتجات ممولة", en: "Sponsored Products" },
  other_products: { ar: "باقي المنتجات", en: "More Products" },

  my_account: { ar: "الحساب", en: "My Account" },
  wallet: { ar: "المحفظة", en: "Wallet" },
  my_favorites: { ar: "تفضيلاتي", en: "My Favorites" },
  my_store: { ar: "صفحتي العامة", en: "My Public Page" },
  my_payments: { ar: "طرق الدفع الخاصة بمتجري", en: "My Store Payment Methods" },
  my_promotions: { ar: "إعلاناتي المموَّلة", en: "My Sponsored Ads" },
  monthly_subscription: { ar: "الاشتراك الشهري", en: "Monthly Subscription" },
  nearby_drivers: { ar: "السائقون القريبون", en: "Nearby Drivers" },
  driver_dashboard: { ar: "لوحة السائق", en: "Driver Dashboard" },
  settings: { ar: "الإعدادات", en: "Settings" },
  notifications: { ar: "الإشعارات", en: "Notifications" },
  language: { ar: "اللغة", en: "Language" },

  admin_panel: { ar: "لوحة المالك", en: "Admin Panel" },
  admin_dashboard: { ar: "لوحة الإحصائيات", en: "Dashboard" },
  manage_payments: { ar: "إدارة طرق الدفع", en: "Payment Methods" },
  manage_subscription: { ar: "اشتراك البائعين", en: "Seller Subscription" },
  manage_driver_sub: { ar: "اشتراك السائقين", en: "Driver Subscription" },
  manage_promotions: { ar: "باقات التمويل + شحن المحفظة", en: "Ad Tiers + Wallet Top-ups" },
  manage_users: { ar: "إدارة المستخدمين", en: "Manage Users" },
  manage_chats: { ar: "مراقبة المحادثات", en: "Monitor Chats" },
  manage_followers: { ar: "إدارة المتابعين", en: "Manage Followers" },
  manage_interests: { ar: "إدارة القوائم/الاهتمامات", en: "Manage Lists/Interests" },
  admin_broadcast: { ar: "إرسال إشعار للمستخدمين", en: "Send Notification" },

  product_name: { ar: "اسم المنتج", en: "Product Name" },
  description: { ar: "الوصف", en: "Description" },
  price: { ar: "السعر", en: "Price" },
  quantity: { ar: "الكمية", en: "Quantity" },
  category: { ar: "الفئة", en: "Category" },
  interests_lists: { ar: "القوائم", en: "Lists" },
  images: { ar: "الصور", en: "Images" },
  buy_now: { ar: "اشترِ الآن", en: "Buy Now" },
  contact_seller: { ar: "تواصل مع البائع", en: "Contact Seller" },
  promote: { ar: "تمويل", en: "Promote" },
  currency_lyd: { ar: "د.ل", en: "LYD" },

  interests_onboard_title: { ar: "ما الذي يهمك؟", en: "What interests you?" },
  interests_onboard_sub: { ar: "اختر حتى 5 قوائم لتخصيص تجربتك", en: "Choose up to 5 lists to personalize your experience" },
  interests_save: { ar: "حفظ ومتابعة", en: "Save & Continue" },
  interests_skip: { ar: "تخطي", en: "Skip" },
  interests_min: { ar: "يجب اختيار قائمة واحدة على الأقل", en: "Choose at least one list" },
  interests_max5: { ar: "الحد الأقصى 5 قوائم", en: "Max 5 lists" },

  favorites_empty: { ar: "لا توجد تفضيلات بعد", en: "No favorites yet" },
  add_to_favorites: { ar: "إضافة للتفضيلات", en: "Add to favorites" },
  remove_from_favorites: { ar: "إزالة من التفضيلات", en: "Remove from favorites" },
  favorite_products: { ar: "المنتجات المفضلة", en: "Favorite Products" },
  favorite_sellers: { ar: "المتاجر المفضلة", en: "Favorite Stores" },

  no_notifications: { ar: "لا توجد إشعارات", en: "No notifications" },
  mark_all_read: { ar: "تعليم الكل كمقروء", en: "Mark all as read" },
  broadcast_title: { ar: "العنوان", en: "Title" },
  broadcast_body: { ar: "نص الرسالة", en: "Message body" },
  broadcast_target: { ar: "المستهدفون", en: "Recipients" },
  broadcast_send: { ar: "إرسال", en: "Send" },
  target_all: { ar: "كل المستخدمين", en: "All Users" },
  target_buyer: { ar: "المشترون فقط", en: "Buyers Only" },
  target_seller: { ar: "البائعون فقط", en: "Sellers Only" },
  target_driver: { ar: "السائقون فقط", en: "Drivers Only" },
  target_user: { ar: "مستخدم محدد", en: "Specific User" },
  broadcast_sent: { ar: "تم الإرسال", en: "Sent" },

  settings_title: { ar: "الإعدادات", en: "Settings" },
  account: { ar: "الحساب", en: "Account" },
  language_ar: { ar: "العربية", en: "Arabic" },
  language_en: { ar: "الإنجليزية", en: "English" },
  push_notifications: { ar: "الإشعارات الفورية", en: "Push Notifications" },
  enable_push: { ar: "تفعيل الإشعارات", en: "Enable notifications" },
  about: { ar: "حول التطبيق", en: "About" },
  version: { ar: "الإصدار", en: "Version" },

  social_links_title: { ar: "روابط التواصل الاجتماعي (اختياري)", en: "Social Media Links (optional)" },
  facebook: { ar: "فيسبوك", en: "Facebook" },
  instagram: { ar: "إنستغرام", en: "Instagram" },
  tiktok: { ar: "تيك توك", en: "TikTok" },
  whatsapp: { ar: "واتساب", en: "WhatsApp" },
  website: { ar: "الموقع الإلكتروني", en: "Website" },
};

export function tr(key, lang = "ar") {
  const entry = STRINGS[key];
  if (!entry) return key;
  return entry[lang] || entry.ar || key;
}
